export function runClearCachesSequence(opts) {
    const entries = [...opts.processors];
    // In-flight paths too: their completions are dropped, so a consumer waiting on one
    // would hang `pending` without the announcement.
    const cleared = entries.map(([type, proc]) => [
        type,
        [...new Set([...proc.cachedPaths(), ...proc.inflightPaths()])],
    ]);
    opts.clearFileBus?.();
    for (const [, proc] of entries) {
        proc.clearCache();
    }
    opts.log?.();
    // After the resets, so a handler's synchronous re-request sees reset caches.
    for (const [type, paths] of cleared) {
        for (const path of paths) {
            opts.eventBus.emit(type, 'invalidated', path);
        }
    }
    // Metadata last: scene re-requests validate their registration during the
    // announcement, and these consumers' register effects do not re-run.
    opts.metadata.clear();
}
//# sourceMappingURL=clearCachesSequence.js.map